import {EnvironmentConfig} from './environment.model';

export const environment : EnvironmentConfig = {
  production: true,
  clientId: 'APP_ENV_CLIENT_ID',
  apiUrl: 'APP_ENV_API_URL',
  finbootApiUrl: 'APP_ENV_FINBOOT_API_URL',
  showExternalErrors: false,
  maxFileSizeMB: 5,
  publicCdnBaseUrl: 'APP_ENV_PUBLIC_CDN_BASE_URL',
  fileServiceUrl: 'APP_ENV_FILE_SERVICE_URL',
  sdsFolder: '/sds',
  docsFolder: '/doc',
  configSDSPath: '/config/bl_samples_sds.json'
};
